import { Box, Button } from "@mui/material";
import React, { memo } from "react";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { toTitleCase } from "../Util/UtilHelper";
import MUITextField from "./MUITextField";
import { VM_Colors } from "../Styles/VMStyles";

const VMFilters = memo((props) => {
  const {
    searchPlaceHolder = "Search...",
    searchValue = "",
    searchOnChange = () => {},
    fromDateValue,
    fromDateOnChange,
    toDateValue,
    toDateOnChange,
    clearOnChange = () => {},
    applyOnChange = () => {},
    actionsAtEnd = true,
    extraFilters = null,
  } = props;

  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        gap: 1.5,
        alignItems: "center",
        width: actionsAtEnd ? "100%" : "auto",
      }}
    >
      {/* Search (min-width only) */}
      <Box
        sx={{
          flex: "0 1 auto",       // no grow
          // minWidth: 200,          // control size here
        }}
      >
        <MUITextField
          placeholder={toTitleCase(searchPlaceHolder)}
          value={searchValue}
          onChange={searchOnChange}
          size="small"
          sx={{
            width: 180, // fixed width instead of fullWidth
            backgroundColor: VM_Colors.transparent,
          }}
        />
      </Box>

      {/* From Date */}
      <Box
        // sx={{
        //   flex: "0 1 200px",
        // }}
      >
        <DatePicker
          label="From Date"
          value={fromDateValue}
          onChange={fromDateOnChange}
          format="DD/MM/YYYY"
          slotProps={{ textField: { size: "small", fullWidth: true } }}
           sx={{
            width: 160, // fixed width instead of fullWidth
            backgroundColor: VM_Colors.transparent,
          }}
        />
      </Box>

      {/* To Date */}
      <Box
        sx={{
          flex: "0 1 200px",
          // minWidth: 180,
        }}
      >
        <DatePicker
          label="To Date"
          value={toDateValue}
          onChange={toDateOnChange}
          format="DD/MM/YYYY"
          slotProps={{ textField: { size: "small", fullWidth: true } }}
           sx={{
            width: 160, // fixed width instead of fullWidth
            backgroundColor: VM_Colors.transparent,
          }}
        />
      </Box>

      {extraFilters}

      {/* Buttons */}
      <Box
        sx={{
          display: "flex",
          gap: 1,
          marginLeft: actionsAtEnd ? "auto" : 0,
          flexWrap: "nowrap",
          width: actionsAtEnd ? { xs: "100%", sm: "auto" } : "auto",
        }}
      >
        <Button
          onClick={clearOnChange}
          variant="outlined"
          sx={{
            minWidth: 90,
            flex: { xs: 1, sm: "unset" },
          }}
        >
          Clear
        </Button>

        <Button
          onClick={applyOnChange}
          variant="contained"
          sx={{
            minWidth: 90,
            flex: { xs: 1, sm: "unset" },
          }}
        >
          Apply
        </Button>
      </Box>
    </Box>
  );
});

export default VMFilters;